var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"xtermWrapper",staticClass:"mt-3",attrs:{"id":"k8s-xterm"}},[_c('div',{staticStyle:{"min-height":"600px"},attrs:{"id":"xterm"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }